import { messages } from '../../../../../messages';
export var getFollowActionErrorMessage = function getFollowActionErrorMessage() {
  var isProject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isFollow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isProject && isFollow) {
    return messages.follow_project_error;
  }
  if (isProject && !isFollow) {
    return messages.unfollow_project_error;
  }
  if (!isProject && isFollow) {
    return messages.follow_goal_error;
  }
  if (!isProject && !isFollow) {
    return messages.unfollow_goal_error;
  }
  return messages.generic_error_message;
};